export default __webpack_public_path__ + "static/media/plain_arrow.2881890d.svg";